import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePostHog } from 'posthog-js/react';


export function useAndInitializePostHog() {
  let location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    if (posthog) {
      posthog.capture(
        '$pageview',
        {
          '$current_url': window.location.href,
        }
      )
    }
  }, [location])

  return null
}
